export const COMPANY_NAME = "GOODWILL ONLINE"
export const COMPANY_NAME_FULL = "GOODWILL ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "GOODWILL ONLINE"
export const META_DESCRIPTION = "Welcome to GOODWILL ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://ibanking.goodwillfin.com"
export const ENABLE_OTHER_DEPOSIT = true
